<template>
  <scrollama @step-enter="setHomeActive">
    <div class="step" data-step="hero">
      <hero />
      <commercial />
    </div>
    <div class="step" data-step="tv">
      <offer title="Nasza oferta TV" mobile-shrink>
        <template #desc>
          <loader :state="actions.templates" without-error>
            <dynamic-content :content="templates[T.TvOffer.DESC]" />
            <template #loading>
              <p
                class="placeholder placeholder--line is-centered has-random-length is-075rem"
              />
              <p
                class="placeholder placeholder--line is-centered has-random-length is-075rem"
              />
              <p
                class="placeholder placeholder--line is-centered has-random-length is-075rem"
              />
            </template>
          </loader>
        </template>
        <template #image>
          <img src="../assets/img/tv.svg" />
        </template>
        <loader :state="actions.templates" without-error>
          <dynamic-content :content="templates[T.TvOffer.OFFER]" />
          <template #loading>
            <p
              class="placeholder placeholder--line has-random-length is-075rem"
            />
            <p
              class="placeholder placeholder--line has-random-length is-075rem"
            />
            <p
              class="placeholder placeholder--line has-random-length is-075rem"
            />
            <p
              class="placeholder placeholder--line has-random-length is-075rem"
            />
            <p
              class="placeholder placeholder--line has-random-length is-075rem"
            />
            <p
              class="placeholder placeholder--line has-random-length is-075rem"
            />
            <p
              class="placeholder placeholder--line has-random-length is-075rem"
            />
            <p
              class="placeholder placeholder--line has-random-length is-075rem"
            />
            <p
              class="placeholder placeholder--line has-random-length is-075rem"
            />
            <p
              class="placeholder placeholder--line has-random-length is-075rem"
            />
            <p
              class="placeholder placeholder--line has-random-length is-075rem"
            />
          </template>
        </loader>
      </offer>
      <offer mirrored mobile-shrink>
        <template #image>
          <img src="../assets/img/videographer.svg" />
        </template>
        <h3>Oferujemy także nasz program własny</h3>
        <loader :state="actions.templates" without-error>
          <dynamic-content :content="templates[T.TvOffer.PROGRAM]" />
          <template #loading>
            <p
              class="placeholder placeholder--line has-random-length is-075rem"
            />
            <p
              class="placeholder placeholder--line has-random-length is-075rem"
            />
            <p
              class="placeholder placeholder--line has-random-length is-075rem"
            />
            <p
              class="placeholder placeholder--line has-random-length is-075rem"
            />
            <p
              class="placeholder placeholder--line has-random-length is-075rem"
            />
            <p
              class="placeholder placeholder--line has-random-length is-075rem"
            />
            <p
              class="placeholder placeholder--line has-random-length is-075rem"
            />
            <p
              class="placeholder placeholder--line has-random-length is-075rem"
            />
          </template>
        </loader>
        <template #packages>
          <h3 class="has-text-centered is-unselectable">Pakiety telewizyjne</h3>
          <loader :state="actions.templates">
            <pricing-table
              id="tv-pricing"
              :disclaimer="templates[T.TvOffer.PRICING_FOOTER]"
              :data="templates[T.TvOffer.PRICING]"
            />
            <template #loading>
              <div
                class="spinner is-3by4 is-grey-lighter is-large is-thick is-centered"
              />
            </template>
            <template #error>
              <p class="error-message">
                Tabela pakietów nie może zostać załadowana ze względu na brak
                połączenia z serwerem.
              </p>
            </template>
          </loader>
        </template>
      </offer>
      <own-program
        :now="now"
        :today="today"
        :blocks="programBlocks"
        :program="program"
        :program-state="[actions.program, actions.blocks]"
        :videos="videos"
        :videos-state="actions.videos"
        @go-to-video="goToVideo"
      />
    </div>
    <div class="step" data-step="internet">
      <offer title="Nasza oferta Internetu" mobile-shrink>
        <template #desc>
          <loader :state="actions.templates" without-error>
            <dynamic-content :content="templates[T.InternetOffer.DESC]" />
            <template #loading>
              <p
                class="placeholder placeholder--line is-centered has-random-length is-075rem"
              />
              <p
                class="placeholder placeholder--line is-centered has-random-length is-075rem"
              />
              <p
                class="placeholder placeholder--line is-centered has-random-length is-075rem"
              />
            </template>
          </loader>
        </template>
        <template #image>
          <img src="../assets/img/internet.svg" />
        </template>
        <loader :state="actions.templates" without-error>
          <dynamic-content :content="templates[T.InternetOffer.OFFER]" />
          <template #loading>
            <p
              class="placeholder placeholder--line has-random-length is-075rem"
            />
            <p
              class="placeholder placeholder--line has-random-length is-075rem"
            />
            <p
              class="placeholder placeholder--line has-random-length is-075rem"
            />
            <p
              class="placeholder placeholder--line has-random-length is-075rem"
            />
            <p
              class="placeholder placeholder--line has-random-length is-075rem"
            />
            <p
              class="placeholder placeholder--line has-random-length is-075rem"
            />
            <p
              class="placeholder placeholder--line has-random-length is-075rem"
            />
            <p
              class="placeholder placeholder--line has-random-length is-075rem"
            />
          </template>
        </loader>
        <template #packages>
          <h3 class="has-text-centered is-unselectable">Pakiety internetowe</h3>
          <loader :state="actions.templates">
            <pricing-table
              id="internet-pricing"
              :disclaimer="templates[T.InternetOffer.PRICING_FOOTER]"
              :data="templates[T.InternetOffer.PRICING]"
            ></pricing-table>
            <template #loading>
              <div
                class="spinner is-3by4 is-grey-lighter is-large is-thick is-centered"
              />
            </template>
            <template #error>
              <p class="error-message">
                Tabela pakietów nie może zostać załadowana ze względu na brak
                połączenia z serwerem.
              </p>
            </template>
          </loader>
        </template>
      </offer>
    </div>
    <div class="step" data-step="contact">
      <loader :state="actions.templates">
        <contact
          :offices="templates[T.Contact.OFFICES]"
          :footer="templates[T.Contact.FOOTER]"
          :breakdown-header="templates[T.Contact.BREAKDOWN_HEADER]"
          :breakdown="templates[T.Contact.BREAKDOWN]"
        />
        <template #loading></template>
        <template #error>
          <div class="contact-error">
            <p>
              Informacje kontaktowe nie mogą zostać załadowane ze względu na
              brak połączenia z serwerem.
            </p>
          </div>
        </template>
      </loader>
    </div>
    <div class="step" data-step="messages">
      <messages
        :messages="favoredMessages"
        @click-message="goToMessage"
        v-if="favoredMessages.length > 0"
      />
    </div>
  </scrollama>
</template>

<script>
import dayjs from "dayjs";
import { mapState, mapGetters } from "vuex";

import { Scrollama, DynamicContent } from "%helpers";
import Hero from "%components/home/Hero";
import Commercial from "%components/home/Commercial";
import OwnProgram from "%components/home/OwnProgram";
import Offer from "%components/home/Offer";
import PricingTable from "%components/home/PricingTable";
import Messages from "%components/home/Messages";
import Contact from "%components/home/Contact";

import { WithTemplates } from "%mixins";

import T from "%const/templates";
import M from "%const/messages";

import { SET_HOME_ACTIVE } from ":mutations";
import { REQUEST_PROGRAM, REQUEST_BLOCKS, FETCH_VIDEOS } from ":actions";

export default {
  name: "home",

  components: {
    Scrollama,
    DynamicContent,
    Hero,
    Commercial,
    OwnProgram,
    Offer,
    PricingTable,
    Messages,
    Contact
  },

  mixins: [
    WithTemplates({
      templates: [
        T.TvOffer.OFFER,
        T.TvOffer.PROGRAM,
        T.TvOffer.PRICING,
        T.InternetOffer.OFFER,
        T.InternetOffer.PRICING,
        T.Contact.OFFICES,
        T.TvOffer.DESC,
        T.TvOffer.PRICING_FOOTER,
        T.InternetOffer.DESC,
        T.InternetOffer.PRICING_FOOTER,
        T.Contact.FOOTER,
        T.Contact.BREAKDOWN_HEADER,
        T.Contact.BREAKDOWN
      ],
      json: [
        T.TvOffer.PRICING,
        T.InternetOffer.PRICING,
        T.Contact.OFFICES,
        T.Contact.BREAKDOWN
      ]
    })
  ],

  props: {
    now: dayjs,
    step: String
  },

  data() {
    return {
      T,

      today: dayjs()
    };
  },

  computed: {
    ...mapGetters(["programBlocks"]),

    ...mapState({
      favoredMessages: state =>
        state.messages.favoredMessages.slice(0, M.Favored.LIMIT),
      program: state => state.program.program,
      videos: state => state.videos.videos.content
    })
  },

  methods: {
    setHomeActive({ element }) {
      this.$store.commit(SET_HOME_ACTIVE, { active: element.dataset.step });
    },

    goToMessage({ message }) {
      this.$router.push(`/messages/${message.id}`);
    },

    async goToVideo(video) {
      await this.$router.push({
        name: "video",
        params: {
          videoId: video.id
        }
      });
      this.$immediatelyScrollToTop();
    },

    scrollToStep(step) {
      const section = step.startsWith("_")
        ? step.replace("_", "#")
        : `*[data-step="${step}"]`;

      this.$scrollTo(section, 2000, {
        offset: -100
      });
    }
  },

  mounted() {
    this.requestTemplates();

    const todayString = dayjs().format("YYYY-MM-DD");
    this.dispatchWithProgress("blocks", REQUEST_BLOCKS);
    this.dispatchWithProgress("program", REQUEST_PROGRAM, {
      from: todayString,
      to: todayString
    });
    this.dispatchWithProgress("videos", FETCH_VIDEOS, {
      page: 1,
      size: 3
    });
  },

  watch: {
    step(val) {
      this.scrollToStep(val);
    },

    actions: {
      deep: true,
      handler() {
        if (this.step && !this.anyAction("loading")) {
          // Disclaimer
          // It's not so beautiful solution, however
          // there is no any other simple option to scroll to given step
          // after DOM update.
          // This solution works also for slow internet connections.
          this.$nextTick(() =>
            setTimeout(() => this.scrollToStep(this.step), 300)
          );
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.home {
  position: relative;

  .step {
    position: relative;
  }
}

.error-message {
  @include unselectable;
  color: $grey-light;
  text-align: center;
  font-size: 1.2rem;
}

.contact-error {
  @include unselectable;
  background-color: $white-ter;
  color: $grey-light;
  padding: 5rem;
  text-align: center;
  font-size: 1.2rem;
}
</style>
